/**
 * Extracts a parameter from the URL if it is present in the correct format.
 *
 * The function checks if the current URL path (obtained via `window.location.pathname`)
 * matches the pattern `/login/<param>`, where `<param>` can be a string composed of alphanumeric
 * characters (`a-z`, `A-Z`, `0-9`) and the `-` (hyphen) character. If the parameter is found,
 * the function returns it; otherwise, it returns `undefined`.
 *
 * @returns {string | undefined} The extracted parameter from the URL if present, otherwise `undefined`.
 *
 * @example
 * Assuming the URL is 'https://example.com/login/abc123':
 * const param = getQueryParam(); // Returns 'abc123'
 *
 * @example
 * Assuming the URL is 'https://example.com/login/':
 * const param = getQueryParam(); // Returns undefined
 *
 * @example
 * Assuming the URL is 'https://example.com/dashboard':
 * const param = getQueryParam(); // Returns undefined
 *
 * The regex used is `/\/login\/([a-zA-Z0-9-]+)$/` and it works as follows:
 * - `\/login\/`: Looks for a path that starts with "/login/".
 * - `([a-zA-Z0-9-]+)`: Captures a sequence of one or more alphanumeric characters or hyphens.
 * - `$`: Ensures that the match is at the end of the path.
 */
export function getQueryParam() {
  const path = window.location.pathname;
  const match = path.match(/\/login\/([a-zA-Z0-9-]+)$/);

  if (match && match[1]) {
    return match[1];
  }

  return undefined;
}
